/* src/app/core/layout/navigation/navigation.component.scss */
:root {
  --ff-montserrat: Montserrat, sans-serif;
  --ff-avenir: Avenir, sans-serif;
  --ff-open-sans: "Open Sans", sans-serif;
  --ff-poppins: "Poppins", sans-serif;
  --fw-light: 300;
  --fw-regular: 400;
  --fw-medium: 500;
  --fw-semi-bold: 600;
  --fw-bold: 700;
  --tess-font-size-3xs: 0.625rem;
  --tess-font-size-2xs: 0.6875rem;
  --tess-font-size-xs: 0.8rem;
  --tess-font-size-sm: 0.75rem;
  --tess-font-size-md: 0.875rem;
  --tess-font-size-2md: 0.925rem;
  --tess-font-size-normal: 1rem;
  --tess-font-size-lg: 1.125rem;
  --tess-font-size-2lg: 1.25rem;
  --tess-font-size-3lg: 1.375rem;
  --tess-font-size-4lg: 1.5rem;
  --tess-font-size-5lg: 1.75rem;
  --tess-font-size-xl: 2rem;
  --tess-font-size-2xl: 2.25rem;
  --tess-font-size-3xl: 2.5rem;
  --tess-font-size-4xl: 2.8rem;
  --tess-font-size-5xl: 3rem;
  --tess-font-size-6xl: 3.25rem;
  --tess-font-size-7xl: 3.5rem;
  --tess-font-size-8xl: 3.75rem;
  --tess-font-size-9xl: 4rem;
  --tess-font-size-10xl: 5rem;
  --tess-font-size-11xl: 6rem;
  --tess-font-size-12xl: 7.5rem;
  --tess-font-size-13xl: 8rem;
  --tess-font-size-14xl: 11rem;
  --tess-neutral-0: #ffffff;
  --tess-neutral-50: #fafafa;
  --tess-neutral-100: #f5f5f5;
  --tess-neutral-200: #ebeef2;
  --tess-neutral-300: #ececec;
  --tess-neutral-350: #e5e5e5;
  --tess-neutral-400: #e0e0e0;
  --tess-neutral-450: #dbdbdb;
  --tess-neutral-500: #d6d6d6;
  --tess-neutral-525: #cccccc;
  --tess-neutral-550: #c1c1c1;
  --tess-neutral-600: #bcbcbc;
  --tess-neutral-650: #aeaeae;
  --tess-neutral-700: #a8a8a8;
  --tess-neutral-750: #a0a0a0;
  --tess-neutral-800: #888888;
  --tess-neutral-825: #666666;
  --tess-neutral-850: #555555;
  --tess-neutral-900: #333333;
  --tess-neutral-925: #444444;
  --tess-neutral-950: #222222;
  --tess-neutral-1000: #000;
  --tess-static-neutral-0: #ffffff;
  --tess-static-neutral-525: #cccccc;
  --tess-static-neutral-800: #888888;
  --tess-static-neutral-900: #333333;
  --tess-static-neutral-1000: #000;
  --tess-brand-300: #ffc107;
  --tess-brand-400: #fbb06f;
  --tess-brand-500: #ff9a00;
  --tess-accent-50: #a8a7b7;
  --tess-accent-100: #c1cede;
  --tess-accent-150: #2e5bff26;
  --tess-accent-200: #90c4f0;
  --tess-accent-300: #61abff;
  --tess-accent-350: #4d82ff;
  --tess-accent-400: #3696f3;
  --tess-accent-500: #1e87f0;
  --tess-accent-600: #1085f7;
  --tess-accent-700: #1077de;
  --tess-accent-750: #0073aa;
  --tess-accent-800: #006491;
  --tess-accent-900: #0d1724;
  --tess-success-100: #4abb85;
  --tess-success-500: #24bd4c;
  --tess-danger-50: #fef2f3;
  --tess-danger-100: #ffc6cb;
  --tess-danger-200: #d9a89a;
  --tess-danger-250: #af7a7a;
  --tess-danger-300: #fb8080;
  --tess-danger-600: #dc3232;
  --tess-danger-650: #d40000;
  --tess-danger-700: #a00a00;
  --tess-main-text: #2c2f49;
  --tess-mat-icon-color: #7c8cac;
  --widgets-color: #2c2f49;
  --tess-surface-card: #ffffff;
  --tess-surface-dropdown-card: #f5f5f5;
  --tess-surface-card-border: var(--tess-neutral-200);
  --tess-widget-hover: #c1cede12;
  --tess-sidebar-bg: #fafafa;
  --tess-sidebar-bg-light: #f5f5f5;
  --tess-main-image-hover:
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.9) 80%,
      white 100%);
  --tess-tb-navbar-shadow: 0 0.1rem 0.31rem 0 rgb(213, 213, 213);
  --tess-template-neutral-0: #ffffff;
  --tess-template-neutral-50: #fafafa;
  --tess-template-neutral-100: #f5f5f5;
  --tess-template-neutral-200: #f0f0f0;
  --tess-template-neutral-300: #ececec;
  --tess-template-neutral-350: #e5e5e5;
  --tess-template-neutral-400: #e0e0e0;
  --tess-template-neutral-450: #dbdbdb;
  --tess-template-neutral-500: #d6d6d6;
  --tess-template-neutral-525: #cccccc;
  --tess-template-neutral-550: #c1c1c1;
  --tess-template-neutral-600: #9ea0a6;
  --tess-template-neutral-650: #aeaeae;
  --tess-template-neutral-700: #a8a8a8;
  --tess-template-neutral-750: #a0a0a0;
  --tess-template-neutral-800: #888888;
  --tess-template-neutral-825: #666666;
  --tess-template-neutral-850: #555555;
  --tess-template-neutral-900: #333333;
  --tess-template-neutral-925: #444444;
  --tess-template-neutral-950: #222222;
  --tess-template-neutral-1000: #000;
  --tess-shadow-top: 0 -0.1rem 0.25rem 0 rgb(255 255 255 / 0.25);
  --tess-template-brand-300: #ffc107;
  --tess-template-brand-400: #fbb06f;
  --tess-template-brand-500: #ff9a00;
  --tess-template-accent-0: #ffffff;
  --tess-template-accent-50: #a8a7b7;
  --tess-template-accent-100: #c1cede;
  --tess-template-accent-150: #2e5bff26;
  --tess-template-accent-200: #90c4f0;
  --tess-template-accent-300: #61abff;
  --tess-template-accent-350: #4d82ff;
  --tess-template-accent-400: #3696f3;
  --tess-template-accent-500: #1e87f0;
  --tess-template-accent-600: #1085f7;
  --tess-template-accent-700: #1077de;
  --tess-template-accent-750: #0073aa;
  --tess-template-accent-800: #006491;
  --tess-template-accent-900: #0d1724;
  --tess-template-success-100: #4abb85;
  --tess-template-success-500: #24bd4c;
  --tess-template-danger-50: #fef2f3;
  --tess-template-danger-100: #ffc6cb;
  --tess-template-danger-200: #d9a89a;
  --tess-template-danger-250: #af7a7a;
  --tess-template-danger-300: #fb8080;
  --tess-template-danger-600: #dc3232;
  --tess-template-danger-650: #d40000;
  --tess-template-danger-700: #a00a00;
  --tess-template-blue-dark: var(--tess-template-neutral-850, var(--tess-template-neutral-800));
}
:root[data-theme=dark] {
  --tess-neutral-0: #0f1115;
  --tess-neutral-50: #171a20;
  --tess-neutral-100: #1d2128;
  --tess-neutral-200: #232830;
  --tess-neutral-300: #2a2f38;
  --tess-neutral-350: #313742;
  --tess-neutral-400: #3a414e;
  --tess-neutral-450: #444b59;
  --tess-neutral-500: #505866;
  --tess-neutral-525: #5b6372;
  --tess-neutral-550: #666f7f;
  --tess-neutral-600: #717a8a;
  --tess-neutral-650: #7c8595;
  --tess-neutral-700: #8a93a2;
  --tess-neutral-750: #98a0ad;
  --tess-neutral-800: #a5adb9;
  --tess-neutral-825: #b3bbc5;
  --tess-neutral-850: #c1c8d0;
  --tess-neutral-900: #d0d5db;
  --tess-neutral-925: #e2e4ea;
  --tess-neutral-950: #eceff3;
  --tess-neutral-1000: #ffffff;
  --tess-shadow-top: 0 -0.1rem 0.25rem 0 rgb(255 255 255 / 0.1);
  --tess-main-text: #e2e4ea;
  --tess-brand-300: #ffb733;
  --tess-brand-400: #f89b3d;
  --tess-brand-500: #ffad33;
  --tess-accent-50: #d3d6f1;
  --tess-accent-100: #a3b9ff;
  --tess-accent-150: #2e5bff26;
  --tess-accent-200: #7fb0ff;
  --tess-accent-300: #61abff;
  --tess-accent-400: #4c9eff;
  --tess-accent-500: #368eff;
  --tess-accent-600: #2c7fea;
  --tess-accent-700: #1f6ad4;
  --tess-accent-750: #1a5fb8;
  --tess-accent-800: #134a8f;
  --tess-accent-900: #0a325d;
  --tess-success-100: #1b9f6e;
  --tess-success-500: #30c37b;
  --tess-danger-50: #3d1618;
  --tess-danger-100: #5b1d20;
  --tess-danger-200: #792529;
  --tess-danger-250: #973032;
  --tess-danger-300: #ba3a3c;
  --tess-danger-600: #e04848;
  --tess-danger-650: #f05c5c;
  --tess-danger-700: #ff7070;
  --tess-mat-icon-color: #e2e4ea;
  --widgets-color: #e2e4ea;
  --tess-surface-card: #1f2027;
  --tess-surface-card-border: #3e414b;
  --tess-sidebar-bg: #121318;
  --tess-main-image-hover:
    linear-gradient(
      to bottom,
      rgb(91 91 91 / 90%) 80%,
      #464646 100%);
  --tess-tb-navbar-shadow: 0 0.1rem 0.31rem 0 rgb(45 44 44);
  --tess-widget-hover: #2a2c34ff;
  color-scheme: dark;
}
.tb-navbar {
  height: 5rem;
  background: var(--tess-neutral-50);
  box-shadow: var(--tess-tb-navbar-shadow);
  z-index: 1;
}
.tb-navbar .uk-navbar-left {
  outline: none;
}
.tb-navbar .uk-navbar-left .toolbar-img {
  height: 1.44rem;
}
.tb-navbar .uk-navbar-left .toolbar-img img {
  margin-top: -0.1rem;
  height: 100%;
}
.tb-navbar .uk-navbar-left .toolbar-title {
  text-transform: uppercase;
  margin-bottom: unset;
  font-size: var(--tess-font-size-md);
  font-weight: var(--fw-semi-bold);
  color: var(--tess-neutral-850);
  margin-left: 0.625rem;
  letter-spacing: 0.2px;
}
.tb-navbar .uk-navbar-nav > li > a {
  text-transform: unset;
  color: var(--tess-neutral-850);
  position: relative;
}
.tb-navbar .uk-navbar-nav > li > a:hover {
  color: var(--tess-neutral-900);
}
.tb-navbar .uk-navbar-nav > li > a:hover::after {
  right: 0.94em;
}
.tb-navbar .uk-navbar-nav > li > a::after {
  position: absolute;
  content: "";
  left: 0.94em;
  top: calc(50% + 0.75rem);
  right: calc(102% - 0.94em);
  height: 0.1rem;
  transition: right 0.3s ease-in-out;
  background-color: var(--tess-accent-400);
}
/*# sourceMappingURL=navigation.component.css.map */
